/* eslint-disable no-unused-vars */
import React, { useEffect, useState, Suspense, lazy } from "react";
import {
  AuthWrapper,
  AuthLeftWrapper,
  LeftWrapperContent,
  LogoWrapper,
} from "./auth.style";
import GlobalStyles from "../../assets/globalStyle";
import logo from "../../assets/school-logo.png";
import "../../assets/style.css";
import "react-phone-input-2/lib/style.css";
import RightSide from "../../components/RightSide";
import Loader from "../../components/pageLoader/loader";

const SendCodeComponent = lazy(() =>
  import("../../components/auth/SendCodeComponent")
);

const VerifyCodeComponent = lazy(() =>
  import("../../components/auth/VerifyCodeComponent")
);

const CreatePinComponent = lazy(() =>
  import("../../components/auth/CreatePinComponent")
);

const Verify = () => {
  const [sendCodeObj, setSendCodeObj] = useState(null);
  
  useEffect(() => {}, [sendCodeObj]);
  let view;
  if (sendCodeObj === null) {
    view = (
      <Suspense fallback={<Loader />}>
        <SendCodeComponent changeCode={setSendCodeObj} />
      </Suspense>
    );
  }

  if (sendCodeObj && sendCodeObj.showComp === "verifyCode") {
    view = (
      <Suspense fallback={<Loader />}>
        <VerifyCodeComponent
          details={sendCodeObj}
          changeCode={setSendCodeObj}
        />
      </Suspense>
    );
  }
  if (sendCodeObj && sendCodeObj.showComp === "createPin") {
    view = (
      <Suspense fallback={<Loader />}>
        <CreatePinComponent details={sendCodeObj} changeCode={setSendCodeObj} />
      </Suspense>
    );
  }

  return (
    <AuthWrapper>
      <GlobalStyles />
      <AuthLeftWrapper>
        <LeftWrapperContent>
          <LogoWrapper>
            <img src={logo} alt="" />
            <div>
              <p>Lagos Anglican Schools</p>
              <p>Management Board</p>
            </div>
          </LogoWrapper>
          {view}
        </LeftWrapperContent>
      </AuthLeftWrapper>

      <RightSide />
    </AuthWrapper>
  );
};

export default Verify;
